import { render, staticRenderFns } from "./Devlop.vue?vue&type=template&id=2832fba4&scoped=true&"
import script from "./Devlop.vue?vue&type=script&lang=js&"
export * from "./Devlop.vue?vue&type=script&lang=js&"
import style0 from "./Devlop.vue?vue&type=style&index=0&id=2832fba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2832fba4",
  null
  
)

export default component.exports